// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerAddressFormStyles } from "@synd/Overrides/Components/CustomerAddressForm";
import { color, modalButtonsActionStyles, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

customerAddressFormStyles.formButtonsWrapper = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding-top: 16px;
        margin-top: 20px;
        border-top: 1px solid ${color("common.border")};
        ${xScreen("lt", "xs")} {
            flex-direction: column-reverse;
            gap: 12px;
        }
    `,
};

customerAddressFormStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};

customerAddressFormStyles.submitButton = {
    ...modalButtonsActionStyles.submitButton,
};
